/**
 * The main component that renders single TabComponent
 * instances.
 */

import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewChild,
  ComponentFactoryResolver,
  OnInit
} from '@angular/core';

import { TabComponent } from './tab.component';
import { DynamicTabsDirective } from './dynamic-tabs.directive';
import { EventService } from 'src/app/core/services/event.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'my-tabs',
  template: `

  <div class="{{estilo}}">
    <ul class="nav nav-tabs">
      <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
        <a href="javascript:void(0)">{{tab.title}}</a>
      </li>
      <!-- dynamic tabs -->
      <li *ngFor="let tab of dynamicTabs; let indice = index" (click)="selectTab(tab)" [class.active]="tab.active">
        <a href="javascript:void(0)" class="btn-navs waves-light">{{tab.title}} <span  *ngIf="tab.isCloseable" (click)="closeTab(tab)">&nbsp; <i class="mdi mdi-close-thick label-icon "></i>
       </span> </a>
      </li>
    </ul>
    </div>
    <!--estilo para vist vertical -->
    <div *ngIf="estilo == 'vertical'">
      <br>
    </div>
        <ng-content></ng-content>
    <ng-template dynamic-tabs #container></ng-template>

  `,
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit, AfterContentInit {
  dynamicTabs: TabComponent[] = [];
  pantalla: string = '';
  estilo: string = '';

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  // almora
  @ViewChild(DynamicTabsDirective) dynamicTabPlaceholder: DynamicTabsDirective;

  private cerrarTabSub: Subscription;

  constructor(private _componentFactoryResolver: ComponentFactoryResolver,
    private eventService: EventService) { }

  // contentChildren are set
  ngAfterContentInit() {

    // get all active tabs
    const activeTabs = this.tabs.filter(tab => tab.active);

    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  openTab(title: string, template, data, isCloseable = false) {

    let isOpen = this.alerta(data);
    if (isOpen == -1) {
      // get a component factory for our TabComponent
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
        TabComponent
      );

      // fetch the view container reference from our anchor directive
      const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
      //let viewContainerRef = this.dynamicTabPlaceholder;

      // create a component instance
      const componentRef = viewContainerRef.createComponent(componentFactory);

      // set the according properties on our component instance
      const instance: TabComponent = componentRef.instance as TabComponent;
      instance.title = title;
      instance.template = template;
      instance.dataContext = data;
      instance.isCloseable = isCloseable;

      // Se guarda SYS02 que esta antes que el checkout (ojo solo para checkout)
      const tabPadreActivo = this.dynamicTabs.find(t => t.active);
      const SYS02CON_PAPA = tabPadreActivo?.dataContext?.SYS02CON ?? null;

      instance.dataContext = { ...data, SYS02CON_PAPA }; // Se agrega en el dataContext

      // remember the dynamic component for rendering the
      // tab navigation headers

      this.dynamicTabs.push(componentRef.instance as TabComponent);

      // set it active
      this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
    } else {
      this.selectTab(this.dynamicTabs[isOpen]);
    }
  }

  selectTab(tab: TabComponent) {
    // deactivate all tabs
    this.tabs.toArray().forEach(tab => (tab.active = false));
    this.dynamicTabs.forEach(tab => (tab.active = false));

    // activate the tab the user has clicked on.
    tab.active = true;
  }

  alerta(data) {
    for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
      if (this.dynamicTabs[i].dataContext.SYS02CON == data.SYS02CON) {

        return i;
      }
    }
    return -1;
  }

  closeTab(tab: TabComponent) {

    for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
      if (this.dynamicTabs[i] === tab) {
        // remove the tab from our array
        this.dynamicTabs.splice(i, 1);

        // destroy our dynamically created component again
        let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
        // let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(i);

        // set tab index to 1st one
        let numTabs = this.dynamicTabs.length;
        if (numTabs > 0) {
          this.selectTab(this.dynamicTabs[numTabs - 1]);
        } else {
          this.selectTab(this.tabs.first);
        }
        break;
      }
    }
  }

  closeActiveTab() {

    const activeTabs = this.dynamicTabs.filter(tab => tab.active);
    if (activeTabs.length > 0) {
      // close the 1st active tab (should only be one at a time)
      this.closeTab(activeTabs[0]);
    }
  }

  ngOnInit(): void {

    // Se registra en la ventana
    this.cerrarTabSub = this.eventService.subscribe('cerrar_tab', (SYS02CON) => {
      const tab = this.dynamicTabs.find(t => t.dataContext?.SYS02CON === SYS02CON);
      if (tab) {
        this.closeTab(tab);
      }
    });

    this.pantalla = this.eventService.pantalla();
    if (this.pantalla == undefined) {
      this.pantalla = "horizontal";
    }

    var es_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    if (es_chrome) {
      if (this.pantalla === "vertical") {
        this.estilo = 'vertical2'
      } else if (this.pantalla === "horizontal") {
        this.estilo = 'horizontal2'
      } else {
        this.estilo = 'vertical2'
      }
    }

    var es_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (es_firefox) {
      if (this.pantalla === "vertical") {
        this.estilo = 'vertical'
      } else if (this.pantalla === "horizontal") {
        this.estilo = 'horizontal'
      } else {
        this.estilo = 'vertical'
      }
    }

    this.eventService.subscribe('cerrar_tabs', (carga) => {
      for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
        let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
        viewContainerRef.remove(i);
      }

      this.dynamicTabs = [];
    });

    this.eventService.subscribe('cerrar_tab', (carga) => {
      for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
        if (this.dynamicTabs[i].dataContext.SYS02CON == carga) {
  
          let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          viewContainerRef.remove(i);
          this.dynamicTabs.splice(i, 1);

          this.selectTab(this.tabs.first);
        }
      }
    });

    this.eventService.subscribe('recargar_tab', (SYS02CON_PAPA) => {
      if (!SYS02CON_PAPA) return;
    
      // se busca el tab padre por su SYS02CON
      const tabPadre = this.dynamicTabs.find(t => t.dataContext?.SYS02CON === SYS02CON_PAPA);
      if (tabPadre) {
        // Se emite el evento de refresco que ya escucha el AdvancedTable
        this.eventService.broadcast('EVENTO_REFRESAR_LISTA_' + SYS02CON_PAPA, {});
      }
    });
  }

  ngOnDestroy() {
    this.cerrarTabSub?.unsubscribe();
  }

}
